import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-306">
      <div className="max-w-5xl mx-auto" data-id="element-307">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-308">
          Lo que <span className="text-[#33BFA6]" data-id="element-309">recibís</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-310">
          {/* Primaria */}
          <div className="bg-black border border-white/20 rounded-2xl p-6" data-id="element-311">
            <h3 className="text-[#33BFA6] text-xl font-black mb-2" data-id="element-312">
              📘 PRIMARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-313">
              Para docentes de Lengua y Literatura de 1° a 6° grado
            </p>
            <div className="space-y-4" data-id="element-314">
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-315">
                <div className="flex items-center gap-3 flex-1" data-id="element-316">
                  <span className="text-xl" data-id="element-317">📘</span>
                  <div data-id="element-318">
                    <span className="font-bold" data-id="element-319">Tomo 1 — 1° Grado:</span>
                    <span className="text-gray-300" data-id="element-320">
                      {' '}
                      La palabra que empieza
                    </span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-321">
                  Oralidad, lectura inicial y escritura emergente
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-322">
                <div className="flex items-center gap-3 flex-1" data-id="element-323">
                  <span className="text-xl" data-id="element-324">📗</span>
                  <div data-id="element-325">
                    <span className="font-bold" data-id="element-326">Tomo 2 — 2° Grado:</span>
                    <span className="text-gray-300" data-id="element-327">
                      {' '}
                      Leer, escribir, imaginar
                    </span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-328">
                  Comprensión lectora y producción de textos breves
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-329">
                <div className="flex items-center gap-3 flex-1" data-id="element-330">
                  <span className="text-xl" data-id="element-331">📙</span>
                  <div data-id="element-332">
                    <span className="font-bold" data-id="element-333">Tomo 3 — 3° Grado:</span>
                    <span className="text-gray-300" data-id="element-334"> Historias y palabras</span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-335">
                  Narrativa, poesía y escritura creativa
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-336">
                <div className="flex items-center gap-3 flex-1" data-id="element-337">
                  <span className="text-xl" data-id="element-338">📕</span>
                  <div data-id="element-339">
                    <span className="font-bold" data-id="element-340">Tomo 4 — 4° Grado:</span>
                    <span className="text-gray-300" data-id="element-341">
                      {' '}
                      Textos que nos hablan
                    </span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-342">
                  Géneros literarios y gramática en contexto
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-343">
                <div className="flex items-center gap-3 flex-1" data-id="element-344">
                  <span className="text-xl" data-id="element-345">📓</span>
                  <div data-id="element-346">
                    <span className="font-bold" data-id="element-347">Tomo 5 — 5° Grado:</span>
                    <span className="text-gray-300" data-id="element-348"> Voces y miradas</span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-349">
                  Literatura, argumentación y ortografía
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-350">
                <div className="flex items-center gap-3 flex-1" data-id="element-351">
                  <span className="text-xl" data-id="element-352">📔</span>
                  <div data-id="element-353">
                    <span className="font-bold" data-id="element-354">Tomo 6 — 6° Grado:</span>
                    <span className="text-gray-300" data-id="element-355"> Palabra en el mundo</span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-356">
                  Textos complejos, producción y reflexión sobre el lenguaje
                </span>
              </div>
            </div>
          </div>

          {/* Secundaria */}
          <div className="bg-black border border-white/20 rounded-2xl p-6" data-id="element-357">
            <h3 className="text-[#33BFA6] text-xl font-black mb-2" data-id="element-358">
              📗 SECUNDARIA — 6 Tomos
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-359">
              Para docentes de Lengua y Literatura de 1° a 6° año
            </p>
            <div className="space-y-4" data-id="element-360">
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-361">
                <div className="flex items-center gap-3 flex-1" data-id="element-362">
                  <span className="text-xl" data-id="element-363">📘</span>
                  <div data-id="element-364">
                    <span className="font-bold" data-id="element-365">Tomo 1 — 1° Año:</span>
                    <span className="text-gray-300" data-id="element-366"> Leer el mundo</span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-367">
                  Narrativa literaria, escritura creativa y análisis textual
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-368">
                <div className="flex items-center gap-3 flex-1" data-id="element-369">
                  <span className="text-xl" data-id="element-370">📗</span>
                  <div data-id="element-371">
                    <span className="font-bold" data-id="element-372">Tomo 2 — 2° Año:</span>
                    <span className="text-gray-300" data-id="element-373"> Lengua viva</span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-374">
                  Géneros discursivos y literatura regional argentina
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-375">
                <div className="flex items-center gap-3 flex-1" data-id="element-376">
                  <span className="text-xl" data-id="element-377">📙</span>
                  <div data-id="element-378">
                    <span className="font-bold" data-id="element-379">Tomo 3 — 3° Año:</span>
                    <span className="text-gray-300" data-id="element-380">
                      {' '}
                      Otras voces, otros mundos
                    </span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-381">
                  Literatura latinoamericana y producción de sentido
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-382">
                <div className="flex items-center gap-3 flex-1" data-id="element-383">
                  <span className="text-xl" data-id="element-384">📕</span>
                  <div data-id="element-385">
                    <span className="font-bold" data-id="element-386">Tomo 4 — 4° Año:</span>
                    <span className="text-gray-300" data-id="element-387">
                      {' '}
                      El poder de la palabra
                    </span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-388">
                  Argumentación, retórica y discurso social
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-389">
                <div className="flex items-center gap-3 flex-1" data-id="element-390">
                  <span className="text-xl" data-id="element-391">📓</span>
                  <div data-id="element-392">
                    <span className="font-bold" data-id="element-393">Tomo 5 — 5° Año:</span>
                    <span className="text-gray-300" data-id="element-394">
                      {' '}
                      Literatura y sociedad
                    </span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-395">
                  Literatura universal y producción académica
                </span>
              </div>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-white" data-id="element-396">
                <div className="flex items-center gap-3 flex-1" data-id="element-397">
                  <span className="text-xl" data-id="element-398">📔</span>
                  <div data-id="element-399">
                    <span className="font-bold" data-id="element-400">Tomo 6 — 6° Año:</span>
                    <span className="text-gray-300" data-id="element-401"> Voz propia</span>
                  </div>
                </div>
                <span className="bg-white/10 text-gray-300 text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full border border-white/30 w-fit" data-id="element-402">
                  Crítica literaria, ensayo y construcción de identidad
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-white/5 border border-white/20 rounded-2xl p-8 text-center" data-id="element-403">
          <h3 className="text-[#33BFA6] text-xl font-black mb-6" data-id="element-404">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-405">
            <div className="flex items-start gap-2 text-left" data-id="element-406">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-407">✅</span>
              <span className="text-white text-sm" data-id="element-408">
                Planificación anual lista para presentar al directivo
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-409">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-410">✅</span>
              <span className="text-white text-sm" data-id="element-411">
                4 unidades didácticas completas con todas las clases del año
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-412">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-413">✅</span>
              <span className="text-white text-sm" data-id="element-414">
                Secuencias didácticas paso a paso con inicio–desarrollo–cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-415">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-416">✅</span>
              <span className="text-white text-sm" data-id="element-417">
                Actividades listas para imprimir y usar en el aula
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-418">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-419">✅</span>
              <span className="text-white text-sm" data-id="element-420">
                Evaluación diagnóstica + 3 evaluaciones trimestrales
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-421">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-422">✅</span>
              <span className="text-white text-sm font-bold" data-id="element-423">
                SOLUCIONARIO COMPLETO con todas las respuestas correctas
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-424">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-425">✅</span>
              <span className="text-white text-sm" data-id="element-426">
                Rúbricas de evaluación oral y escrita
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-427">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-428">✅</span>
              <span className="text-white text-sm" data-id="element-429">
                Autoevaluación del alumno incluida
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-430">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-431">✅</span>
              <span className="text-white text-sm" data-id="element-432">
                Portfolio sugerido por unidad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-433">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-434">✅</span>
              <span className="text-white text-sm" data-id="element-435">
                100% alineado a NAP Argentina y Diseños Curriculares
                provinciales
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-436">
              <span className="text-green-400 font-bold flex-shrink-0" data-id="element-437">✅</span>
              <span className="text-white text-sm" data-id="element-438">
                Bibliografía oficial al finalizar cada tomo
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}